import React from "react";
import "./Button.scss";
import { CircularProgress } from "@material-ui/core";

const Button = ({
  text,
  isSubmit,
  onClick,
  showLoading,
  invert,
  black,
  width = "45%",
}) => (
  <button
    type={isSubmit ? "submit" : "button"}
    className={` ${invert ? "invert" : null} Button`}
    onClick={onClick}
    style={{
      width,
      backgroundColor: black ? "rgb(45, 45, 45)" : "#6d6d6d",
    }}
  >
    {!showLoading ? text : <CircularProgress size={20} color="white" />}
  </button>
);

export default Button;
